import React from 'react'
import styled from 'styled-components'
import Throbber from '../DesignerCommon/Throbber'

const Container = styled.div`
  width: 136px;
  height: 172px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 800px) {
    min-width: 30%;
    flex: 1;
    flex-grow: 1;
    flex-shrink: 0;
    height: 158px;
    box-sizing: border-box;
  }
`

const FeedLoadingCard = () => {
  return (
    <Container>
      <Throbber />
    </Container>
  )
}

export default FeedLoadingCard
